import * as React from 'react'
import Icon from '@mui/icons-material/Group'

// import { UserCreate } from './create';
import { UserEdit } from './edit'
import { UserList } from './list'
// import { UserShow } from './show';
import { ComponentWithSubheader } from 'dash/shared'

export default class User {
  // static Create = UserCreate;
  static Edit = () => {
    return <ComponentWithSubheader path={['Admin', 'Users']} component={UserEdit} />
  }
  static List = () => <ComponentWithSubheader path={['Admin']} label="Users" component={UserList} />
  static Icon = Icon
  // static Show = UserShow;
}
